export default __webpack_public_path__ + "static/media/rob-min.d18f438a.png";